import React from 'react';
import { useDownloads } from '../Downloads/containers/DownloadsDataStore';
import ReviewCopyDownloadModalAnchor from '../ReviewCopy/ReviewCopyDownloadModalAnchor';

type DrcActionDownloadOptionProps = {
	title: any;
	children?: React.ReactNode;
	tooltipPlacement: string;
	doAllowOpenReviewCopyActionOnMount: boolean;
};

DrcActionDownloadOption.defaultProps = {
	doAllowOpenReviewCopyActionOnMount: false,
};

export default function DrcActionDownloadOption({
	title,
	children,
	tooltipPlacement,
	doAllowOpenReviewCopyActionOnMount,
}: DrcActionDownloadOptionProps) {
	const { sku } = title;
	const downloadsDataStore = useDownloads();
	const { downloads, isLoading } = downloadsDataStore.state;

	if (isLoading) {
		return <React.Fragment />;
	}

	const render = () => {
		const thisDownload =
			downloads && downloads.filter(req => req.sku === sku);
		if (thisDownload && thisDownload.length > 0) {
			return (
				<ReviewCopyDownloadModalAnchor
					title={title}
					tooltipPlacement={tooltipPlacement}
					digitalCreatedDate={title.digitalCreatedDate}
					digitalUpdatedDate={title.digitalUpdatedDate}
					downloadDate={thisDownload[0].downloadDate}
					doAllowOpenOnMount={doAllowOpenReviewCopyActionOnMount}
				/>
			);
		} else {
			return (
				<ReviewCopyDownloadModalAnchor
					title={title}
					tooltipPlacement={tooltipPlacement}
					digitalCreatedDate={title.digitalCreatedDate}
					digitalUpdatedDate={title.digitalUpdatedDate}
					doAllowOpenOnMount={doAllowOpenReviewCopyActionOnMount}
				/>
			);
		}
	};

	if (!children) {
		return render();
	}

	return (
		<div style={{ display: 'flex' }}>
			{render()}
			{children}
		</div>
	);
}
